<template>
  <div>
    <form class="xcard" @submit.prevent="validarCampos" style="margin-top: 0" novalidate>
      <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
      <h3 class="text-center">Modificar Datos de Usuario del Sistema</h3>
      <p class="text-center text-primary" style="margin-bottom: 0">
        <small class="center-block"> Los campos con un asterisco <span class="text-danger">*</span> son obligatorios </small>
      </p>

      <p class="text-primary"><b>Datos personales</b></p>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group" :class="{ 'has-error': validation.hasError('persona.num_doc') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger">*</span> Documento:</div>
              <input type="text" v-model.trim="persona.num_doc" class="form-control" placeholder="Documento de identidad sin extension" />
            </div>
            <div class="error" v-if="validation.hasError('persona.num_doc')">{{ validation.firstError('persona.num_doc') }}</div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('persona.iddepartamento') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon">Expedido:</div>
              <Departamentos :model="persona" :default="persona.iddepartamento" />
            </div>
            <div class="error" v-if="validation.hasError('persona.iddepartamento')">{{ validation.firstError('persona.iddepartamento') }}</div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('persona.nombres') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger">*</span> Nombres:</div>
              <input type="text" v-model.trim="persona.nombres" class="form-control" placeholder="Primer y segundo nombre" />
            </div>
            <div class="error" v-if="validation.hasError('persona.nombres')">{{ validation.firstError('persona.nombres') }}</div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('persona.pri_apellido') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger">*</span> Apellido 1:</div>
              <input type="text" v-model.trim="persona.pri_apellido" class="form-control" placeholder="Primer apellido" />
            </div>
            <div class="error" v-if="validation.hasError('persona.pri_apellido')">{{ validation.firstError('persona.pri_apellido') }}</div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('persona.seg_apellido') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon">Apellido 2:</div>
              <input type="text" v-model.trim="persona.seg_apellido" class="form-control" placeholder="Segundo apellido (Si tiene)" />
            </div>
            <div class="error" v-if="validation.hasError('persona.seg_apellido')">{{ validation.firstError('persona.seg_apellido') }}</div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('persona.email') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger">*</span> Correo:</div>
              <input type="text" v-model.trim="persona.email" class="form-control" placeholder="Correo electronico" />
            </div>
            <div class="error" v-if="validation.hasError('persona.email')">{{ validation.firstError('persona.email') }}</div>
          </div>

          <div class="form-group" :class="{ 'has-error': validation.hasError('persona.sexo') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger">*</span> Sexo:</div>
              <select v-model.trim="persona.sexo" class="form-control">
                <option value="F">Mujer</option>
                <option value="M">Hombre</option>
                <option value="O">Otros</option>
              </select>
            </div>
            <div class="error" v-if="validation.hasError('persona.sexo')">{{ validation.firstError('persona.sexo') }}</div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('persona.diestro') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger">*</span> Diestro:</div>
              <select v-model.trim="persona.diestro" class="form-control">
                <option value="true">Si</option>
                <option value="false">No</option>
              </select>
            </div>
            <div class="error" v-if="validation.hasError('persona.diestro')">{{ validation.firstError('persona.diestro') }}</div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('idprofesion.idprofesion') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger">*</span> Profesiones</div>
              <Profesiones :model="idprofesion" v-bind:multiple="true" :default="persona.idprofesion" />
            </div>
            <div class="error" v-if="validation.hasError('idprofesion.idprofesion')">{{ validation.firstError('idprofesion.idprofesion') }}</div>
          </div>

          <div class="xcard">
            <label><span class="text-danger">* </span> Foto de perfil: </label>
            <p><small>Esta imagen se usa como foto de perfil del usuario(sobre todo marketing para el ranking de asesores)</small></p>
            <div class="form-group form-group-sm" :class="{ 'has-error': validation.hasError('avatar') }">
              <div class="input-group input-group-sm">
                <div class="input-group-addon">
                  <label for="fotoFile" class="btn btn-rounded btn-success">Seleccione Una Imagen</label>
                  <input type="file" style="visibility: hidden" id="fotoFile" @click="resetFotoUploader" @change="uploadFoto" accept=".jpg, .jpeg, .png" ref="fotoFile"/>
                </div>
              </div>
              <input type="hidden" v-model.trim="avatar" />
              <div class="error" v-if="validation.hasError('avatar')">{{ validation.firstError('avatar') }}</div>
            </div>
            <div class="container-fluid">
              <img class="img-responsive" alt="avatar" :src="location_user_pick + avatar" />
              <!-- <small> {{ avatar }} </small> -->
            </div>
          </div>

          <Menus />
        </div>

        <div class="col-sm-6">
          <div class="form-group" :class="{ 'has-error': validation.hasError('persona.idpais') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon">Pais</div>
              <Paises :model="persona" :default="persona.idpais" />
            </div>
            <div class="error" v-if="validation.hasError('persona.idpais')">{{ validation.firstError('persona.idpais') }}</div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('persona.idinstitucion') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon">Institucion</div>
              <Universidades :model="persona" :default="persona.idinstitucion" />
            </div>
            <div><small class="text-primary">Institucion o Universidad de egreso.</small></div>
            <div class="error" v-if="validation.hasError('persona.idinstitucion')">{{ validation.firstError('persona.idinstitucion') }}</div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('persona.idciudad') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon">Ciudad</div>
              <Ciudades :model="persona" :default="persona.idciudad" />
            </div>
            <div class="error" v-if="validation.hasError('persona.idciudad')">{{ validation.firstError('persona.idciudad') }}</div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('persona.usuario_moodle') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon">Usuario Moodle</div>
              <input type="text" v-model.trim="persona.usuario_moodle" class="form-control" />
            </div>
            <div class="error" v-if="validation.hasError('persona.usuario_moodle')">{{ validation.firstError('persona.usuario_moodle') }}</div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('persona.clave_moodle') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon">Clave Moodle</div>
              <input type="text" v-model.trim="persona.clave_moodle" class="form-control" />
            </div>
            <div class="error" v-if="validation.hasError('persona.clave_moodle')">{{ validation.firstError('persona.clave_moodle') }}</div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('persona.telefono1') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon">Telefono 1</div>
              <input type="text" v-model.trim="persona.telefono1" class="form-control" />
            </div>
            <div class="error" v-if="validation.hasError('persona.telefono1')">{{ validation.firstError('persona.telefono1') }}</div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('persona.telefono2') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon">Telefono 2</div>
              <input type="text" v-model.trim="persona.telefono2" class="form-control" />
            </div>
            <div class="error" v-if="validation.hasError('persona.telefono2')">{{ validation.firstError('persona.telefono2') }}</div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('persona.domicilio') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon">Domicilio</div>
              <input type="text" v-model.trim="persona.domicilio" class="form-control" />
            </div>
            <div class="error" v-if="validation.hasError('persona.domicilio')">{{ validation.firstError('persona.domicilio') }}</div>
          </div>

          <div class="form-group">
            <div class="input-group input-group-sm" :class="{ 'has-error': validation.hasError('persona.fecha_nac') }">
              <div class="input-group-addon">Fecha de nac.</div>
              <Fecha :model="persona" valueto="fecha_nac" :default="persona.fecha_nac" />
            </div>
            <div class="error" v-if="validation.hasError('persona.fecha_nac')">{{ validation.firstError('persona.fecha_nac') }}</div>
          </div>
          <div class="xcard">
            <p class="text-center text-primary">Seleccione una firma <span class="text-default">.png</span> para el recibo (250x150)</p>
            <div class="form-group form-group-sm" :class="{ 'has-error': validation.hasError('bg_firma') }">
              <div class="input-group input-group-sm">
                <div class="input-group-addon">
                  <label for="firmaFile" class="btn btn-rounded btn-primary">Seleccione una imagen</label>
                  <input
                    type="file"
                    style="visibility: hidden"
                    id="firmaFile"
                    @click="resetImageUploader"
                    @change="uploadUserFirma"
                    accept=".jpg, .jpeg, .png"
                    ref="firmaFile"
                  />
                </div>
              </div>
              <input type="hidden" v-model.trim="bg_firma" />
              <div class="error" v-if="validation.hasError('bg_firma')">{{ validation.firstError('bg_firma') }}</div>
            </div>
            <div class="container-fluid">
              <img class="img-responsive" alt="firma fondo" :src="location_user_firma + bg_firma" />
            </div>
            <!-- <p>{{ bg_firma }}</p> -->
          </div>
        </div>
      </div>

      <p v-if="validation.hasError('cargos')" class="text-danger" style="margin-bottom: 0">Indique los cargos y sedes</p>
      <Asignar v-show="true" :model="cargos" :default="persona.carguitos" />

      <Alertas ref="alertar" />
      <p class="text-center">{{ msg }}</p>
      <button :disabled="!activo" type="submit" class="btn btn-sm btn-azul center-block">Aceptar</button>
    </form>

    <notifications group="auth" position="bottom right" />
    <notifications group="auth4" position="bottom right" />
  </div>
</template>

<script>
import gql from 'graphql-tag';
import Profesiones from '@/components/AProfesiones.vue';
import Departamentos from '@/components/ADepartamentos.vue';
import Paises from '@/components/APaises.vue';
import Universidades from '@/components/AUniversidades.vue';
import Ciudades from '@/components/ACiudades.vue';
import Fecha from '@/components/AFecha.vue';
import Asignar from '@/components/AAsignarCargo.vue';
import Alertas from '@/components/AAlertas.vue';
import Menus from '@/components/AMenus.vue';
import xaxios from '@/xaxios';
import { parseJsonError, error } from '@/components/Utils.js';
import { Validator } from 'simple-vue-validator';

export default {
  data() {
    return {
      avatar: null,
      bg_firma: null,
      location_user_pick: process.env.VUE_APP_URL_USERPICK,
      location_user_firma: process.env.VUE_APP_URL_BG_FIRMA_USER,
      activo: true,
      msg: '',
      universidades: [],
      postgrados: [],
      sedes: [],
      gestiones: [],
      persona: {
        num_doc: null,
        nombres: null,
        pri_apellido: null,
        email: null,
        sexo: null,
        tipo: 'P',
        diestro: true,
        idprofesion: null,
        profesiones: [],

        grados: [],
        idpais: null,
        iddepartamento: null,
        idinstitucion: null,
        idciudad: null,
        contacto: null,
        datos_laborales: null,
        clave_moodle: null,
        usuario_moodle: null,
        est_civil: null,
        fecha_nac: null,
        telefono2: null,
        telefono1: null,
        domicilio: null,
        seg_apellido: null,
        carguitos: [],
      },
      idprofesion: { idprofesion: [] },
      usuario: {
        login: null,
        clave: null,
        correo_corp: null,
        observacion: null,
        foto: 'userdefault.png',
      },
      cargos: [],
    };
  },
  components: { Profesiones, Departamentos, Paises, Universidades, Ciudades, Fecha, Alertas, Menus, Asignar },
  validators: {
    'idprofesion.idprofesion'(value) {
      return Validator.value(value).required();
    },

    'persona.num_doc'(value) {
      return Validator.value(value).required().minLength(7);
    },
    'persona.nombres'(value) {
      return Validator.value(value).regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$').required().minLength(2);
    },
    'persona.pri_apellido'(value) {
      return Validator.value(value).regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$').required().minLength(2);
    },
    'persona.email'(value) {
      // return Validator.value(value).required().email();
      const v = Validator.value(value).email().required();
        const ms = Object.keys(v._messages).length; 
        if(ms==0){
          return Validator.value(value).regex(/^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/);
        }
        return v;
    },
    'persona.sexo'(value) {
      return Validator.value(value).required();
    },
    'persona.tipo'(value) {
      return Validator.value(value).required();
    },
    'persona.diestro'(value) {
      return Validator.value(value).required();
    },

    'persona.seg_apellido'(value) {
      return Validator.value(value).minLength(0).regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$');
    },
    'persona.domicilio'(value) {
      return Validator.value(value).minLength(0).regex('^([a-zñáéíóúA-ZÁÉÍÓÚÑ 0-9])([a-zñáéíóúA-ZÁÉÍÓÚÑ 0-9 % # ° / : , \' " “ ” - . _ & ()]+)$');
    },
    // avatar(value) {
    //   return Validator.value(value).required();
    // },
    // bg_firma(value) {
    //   return Validator.value(value).required();
    // },

    //'cargos'(value){ return Validator.value(value).required(); }, // recien lo quite ??/ servia?/
  },
  watch: {
    persona: {
      deep: true,
      handler() {
        window.sessionStorage.setItem('xxpersona', JSON.stringify(this.persona));
      },
    },
    usuario: {
      deep: true,
      handler() {
        window.sessionStorage.setItem('xusuario', JSON.stringify(this.usuario));
      },
    },
    'idprofesion.idprofesion': {
      deep: true,
      handler() {
        this.setProfesiones();
      },
    },
  },
  methods: {
    validarCampos() {
      this.$refs.alertar.reset();
      this.parseBoolean();
      this.$validate().then((success) => {
        var obj = window.Object.assign({}, this.persona);
        var obj2 = window.Object.assign({}, this.usuario);
        delete obj.ciudad;
        delete obj.departamento;
        delete obj.pais;
        delete obj.usuario;
        delete obj.idprofesion;
        delete obj.carguitos;
        delete obj.__typename;
        delete obj2.__typename;
        delete obj2.cargos;
        delete obj2.datos_personales;
        delete obj2.id;
        delete obj2.estado;
        delete obj2.login;
        delete obj2.clave;

        if (success) {
          // estas acciones van en par, set el objeto para luego limpiar campos nulos
          if (obj.iddepartamento) obj.iddepartamento = obj.iddepartamento.id;
          if (obj.idciudad) obj.idciudad = obj.idciudad.id;
          if (obj.iduniversidad) obj.idinstitucion = obj.iduniversidad.id;
          if (obj.institucion) obj.idinstitucion = obj.institucion.id;
          if (obj.idpais) obj.idpais = obj.idpais.id;
          delete obj.institucion;
          delete obj.iduniversidad;
          this.$store.state.obj = obj;
          this.$store.dispatch('quitarNulos');

          this.$store.state.obj = obj2;
          this.$store.dispatch('quitarNulos');

          this.activo = false;
          this.$refs.alertar.cargando();
          // window.console.log( "SSSSS",window.stringifyObject(obj),window.stringifyObject(obj2),window.stringifyObject(this.cargos) );
          this.enviarDatos(obj, obj2);
        } else {
          // window.console.log( "HHHHH",window.stringifyObject(obj),window.stringifyObject(obj2),window.stringifyObject(this.cargos) );
          this.$refs.alertar.invalido();
        }
      });
    },
    setProfesiones() {
      this.persona.profesiones = [];
      if (this.idprofesion.idprofesion == null) return;
      var vue = this;
      vue.idprofesion.idprofesion.forEach(function (e) {
        vue.persona.profesiones.push(e.id);
      });
    },
    parseBoolean() {
      if (this.persona.diestro == 'true') this.persona.diestro = true;
      else this.persona.diestro = false;
    },
    resetFotoUploader() {
      this.avatar = 'userdefault.png';
      this.$refs.fotoFile.value = '';
    },
    uploadFoto() {
      const img_cert = this.$refs.fotoFile.files[0];
      if (img_cert.size / 1000 < 1024) {
        let url = `${process.env.VUE_APP_URL_WEBDATA}fotoperfil_upload.php`;
        let formData = new FormData();
        formData.append('file', img_cert);

        xaxios
          .post(url, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          .then(({ data: { status, msg, newCertName } }) => {
            this.avatar = status ? newCertName : 'userdefault';
            this.$root.$notify.show(`${msg} ${newCertName}`, { color: 'success' });
            if (status) {
              window.alert('Imagen de usuario cargada, guarde los datos para aplicar los cambios');
            }
          })
          .catch(({ response }) => {
            this.resetFotoUploader();
            this.$root.$notify.show(`${response.data}`, { color: 'red' });
          });
      } else {
        this.resetFotoUploader();
        this.$root.$notify.show(`El archivo debe ser Menor a 1MB`, { color: 'red' });
      }
    },
    resetImageUploader() {
      this.bg_firma = null;
      this.$refs.firmaFile.value = '';
    },
    uploadUserFirma() {
      const img_file = this.$refs.firmaFile.files[0];
      if (img_file.size / 1000 < 1024) {
        let url = `${process.env.VUE_APP_URL_WEBDATA}upload_firma_user.php`;

        let formData = new FormData();
        formData.append('file', img_file);

        xaxios
          .post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(({ data: { status, msg, fileNameFirma } }) => {
            this.bg_firma = status ? fileNameFirma : null;
            this.$root.$notify.show(`${msg} ${fileNameFirma}`, { color: 'success' });
          })
          .catch((error) => {
            this.resetImageUploader();
            this.$notify(error('Error: ' + url, error));
          });
      } else {
        this.resetImageUploader();
        this.$notify(error('Recibo', 'El archivo debe ser Menor a 1MB'));
      }
    },
    getDatos() {
      this.persona.carguitos = []; 
      var vue = this;
      var sql = gql`
          query{
            getPersona(id:${this.usuario.id}){
              id num_doc,nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,
              email,sexo,tipo,fecha_nac,fecha_reg,diestro,usuario_moodle,ciudad{id,nombre},departamento{id,nombre,extension},
              profesiones{id,nombre},pais{id,nombre},institucion{id,nombre},usuario{firma,foto,cargos{cargo{id,nombre},sede{id,nombre},desde}}
            }
          }
          `;
      //   window.console.log( "+++++++++++++++++++++",sql )
      this.$apollo
        .mutate({
          mutation: sql,
        })
        .then((data) => {
          this.persona = data.data.getPersona;
          this.persona.iddepartamento = this.persona.departamento;
          this.persona.idciudad = this.persona.ciudad;
          this.persona.idpais = this.persona.pais;
          this.avatar = this.persona.usuario.foto;
          this.bg_firma = this.persona.usuario.firma;
          this.persona.idinstitucion = this.persona.institucion;
          if (this.persona.profesiones.length) this.persona.idprofesion = this.persona.profesiones;
          else {
            //this.persona.profesiones = [];
            this.persona.idprofesion = [];
          }

          delete this.persona.profesiones;
          var cc = [];
          this.persona.usuario.cargos.forEach(function (e) {
            cc.push({ idcargo: { id: e.cargo.id, nombre: e.cargo.nombre }, idsede: { id: e.sede.id, nombre: e.sede.nombre }, desde: e.desde });
          });
          this.persona.carguitos = cc;
          //window.console.log( "PERSONA: ",window.stringifyObject(this.persona) )
        })
        .catch((error) => {
          vue.$refs.alertar.invalido();
          this.activo = true;
          window.console.error(error);
          this.$notify(parseJsonError(error));
        });
    },
    simpleValues(obj) {
      for (const key in obj) {
        if (obj.hasOwnProperty(key) && obj[key] === null) {
          delete obj[key];
        }
      }
      return obj;
    },

    async enviarDatos(obj) {
      let formUser = {
        foto: this.avatar,
        firma: this.bg_firma,
      };
      formUser = this.simpleValues(formUser);
      // window.console.log(obj);
      delete obj.fecha_reg
      // window.console.log('obj', obj, 'obj2', formUser);
      // window.console.log(obj);
      var vue = this;
      var sql = gql`mutation{ updateUsuarioPersona(input:{ usuario:${window.stringifyObject(formUser)},persona:${window.stringifyObject(obj)} })
      {ok,errors{message}} }`;

      // window.console.log('mutation{ updateUsuarioPersona', sql);
      this.$apollo
        .mutate({
          mutation: sql,
        })
        .then(({data}) => {
          if (data.updateUsuarioPersona.ok) {
            vue.$refs.alertar.success();
            window.sessionStorage.setItem('xusuario', null);
          } else {
            var errores = JSON.stringify(data.updateUsuarioPersona.errors);
            var obj = JSON.parse(errores);
            var vals = '';
            obj.forEach(function (k) {
              vals += Object.values(k) + '-\n\t';
            });
            vue.activo = true;
            vue.$refs.alertar.invalido(vals);
          }
        })
        .catch((error) => {
          vue.$refs.alertar.invalido();
          this.activo = true;
          window.console.error(error);
          this.$notify(parseJsonError(error));
        });
    },
    /*async deshabilitar( obj,obj2 ){
            var vue = this;
            var sql = gql`mutation{ deshabilitarCargoUsuarioSede(input:{ usuario:${window.stringifyObject(obj2)},persona:${window.stringifyObject(obj)} }){ok,errors{message}} }`

            window.console.log( "+++++++++++++++++++++",sql )
            this.$apollo.mutate({
                mutation: sql,
            }).then((data) => {
                window.console.log(data.data.deshabilitarCargoUsuarioSede);
                
            }).catch((error) => {
                vue.$refs.alertar.invalido();
                this.activo = true;
                window.console.error(error);
                this.$notify( parseJsonError( error ) )
            })

        }*/
  },
  mounted() {
    var xp = sessionStorage.xxpersona;
    var xu = sessionStorage.xxusuario;
    if (xp != null) this.persona = JSON.parse(xp);
    if (xu != null) this.usuario = JSON.parse(xu);
    this.usuario.clave = '';
    //if( this.usuario ) this.persona = this.usuario.datos_personales;
    this.getDatos();
  },
};
</script>